// extracted by mini-css-extract-plugin
export default {"fof_page":"_404_fof_page__w+0Q9","fof_box":"_404_fof_box__4pZUy"};